// Mappa redirect: vecchie URL torri.solar -> nuove URL.
// English (/en/...) volutamente ESCLUSO: verra' gestito quando creeremo la versione EN.
// I prodotti con slug identico (es. /prodotto/half-cell-4-0) NON sono qui: il nuovo
// sito li serve gia' allo stesso path.

export const exactRedirects = {
  // Prodotti: vecchi slug del sito precedente -> nuovi slug attuali
  "/prodotto/half-cell": "/prodotto/half-cell-4-0",
  "/prodotto/silvered": "/prodotto/silvered-4-0",

  // Prodotti "arti-fix" senza pagina dedicata -> categoria Sistemi di fissaggio
  "/prodotto/arti-fix-tetto-a-falda": "/prodotti/sistemi-di-fissaggio",
  "/prodotto/arti-fix-tetto-in-lamiera": "/prodotti/sistemi-di-fissaggio",
  "/prodotto/arti-fix-tetto-piano": "/prodotti/sistemi-di-fissaggio",

  // Tecnologie: vecchie pagine separate -> pagina unica /tecnologia
  "/tecnologie/aura": "/tecnologia",
  "/tecnologie/eco-red": "/tecnologia",
  "/tecnologie/tecnologia-prisma-4-0": "/tecnologia",
  "/tecnologie/tecnologia-x-core²": "/tecnologia",

  // Chiavi in mano: vecchie landing -> hub unico /chiavi-in-mano
  "/impianti-fotovoltaici-chiavi-in-mano": "/chiavi-in-mano",
  "/impianto-fotovoltaico-chiavi-in-mano": "/chiavi-in-mano",
  "/impianti-fotovoltaici-per-aziende": "/chiavi-in-mano",

  // News: i 18 articoli importati -> nuova pagina articolo
  "/fiere/torri-la-nuova-frontiera-della-energia-solare": "/news/1",
  "/press/dalla-fonderia-alla-fabbrica-di-pannelli-fotovoltaici": "/news/2",
  "/sponsor/la-serie-a-di-pallacanestro-e-entrata-in-fabbrica-con-noi": "/news/3",
  "/educational/come-si-produce-un-pannello-fotovoltaico": "/news/4",
  "/educational/i-pannelli-solari-resistono-alla-grandine": "/news/5",
  "/educational/a-cosa-serve-il-silicio-nei-pannelli-fotovoltaici": "/news/6",
  "/educational/a-cosa-serve-il-polimero-nei-pannelli-fotovoltaici": "/news/7",
  "/educational/quanto-costa-un-pannello-fotovoltaico": "/news/8",
  "/educational/un-pannello-fotovoltaico-si-puo-calpestare": "/news/9",
  "/press/durabilita-affidabilita-e-qualita-costruttiva-sono-lanima-della-tecnologia-italiana-con-pv-magazine": "/news/10",
  "/fiere/torri-a-key-energy-2026-innovazione-fabbrica-e-tecnologie-brevettate-per-una-nuova-generazione-di-fotovoltaico": "/news/11",
  "/bandi/bando-agrisolare-2026-fino-all80-di-fondo-perduto-per-i-pannelli-fotovoltaici-torri": "/news/12",
  "/eventi/fotovoltaico-made-in-italy-dalla-fabbrica-torri-la-visione-tecnica-e-tecnologica-per-sicurezza-e-longevita-degli-impianti": "/news/13",
  "/press/torri-x-core²-la-nuova-frontiera-della-sicurezza-nel-fotovoltaico": "/news/14",
  "/eventi/anteprima-x-core²-un-nuovo-riferimento-per-la-sicurezza-nel-fotovoltaico": "/news/15",
  "/press/torri-solare-al-giornale-di-brescia-nasce-la-comunita-energetica-nazionale-torri-una-visione-industriale-per-il-fotovoltaico-made-in-italy": "/news/16",
  "/eventi/torri-confartigianato-mantova-eccellenza-e-nel-dna-dei-nostri-territori": "/news/17",
  "/fiere/torri-al-key-energy-2025": "/news/18",

  // Vecchie pagine istituzionali WordPress -> nuove sezioni
  "/il-gruppo": "/azienda",
  "/chi-siamo": "/azienda",
  "/azienda-torri": "/azienda",
  "/storia": "/azienda",
  "/tecnologie": "/tecnologia",
  "/prodotti-torri": "/prodotti",
  "/shop": "/prodotti",
  "/negozio": "/prodotti",
  "/contattaci": "/contatti",
  "/contatti-torri": "/contatti",
  "/diventa-installatore": "/installatori",
  "/installatore": "/installatori",
  "/blog": "/news",
  "/privacy-policy": "/legali/privacy-policy",
  "/cookie-policy": "/legali/cookie-policy",

  // Mercato: articolo editoriale ben posizionato -> nuova news
  "/mercato/fotovoltaico-made-in-italy-per-lindustria-prodotti-di-eccellenza-con-il-massimo-incentivo-5-0": "/news/19",
};

// Prefissi delle vecchie categorie blog: ogni post NON mappato sopra -> /news
export const prefixRedirects = [
  ["/press/", "/news"],
  ["/eventi/", "/news"],
  ["/fiere/", "/news"],
  ["/educational/", "/news"],
  ["/sponsor/", "/news"],
  ["/bandi/", "/news"],
  ["/mercato/", "/news"],
  ["/tecnologie/", "/tecnologia"],
  ["/il-gruppo/", "/azienda"],
  ["/category/", "/news"],
  ["/tag/", "/news"],
  ["/author/", "/news"],
  ["/feed", "/news"],
  ["/product-category/", "/prodotti"],
  ["/categoria-prodotto/", "/prodotti"],
  ["/wp-content/", "/"],
  ["/wp-admin", "/"],
  ["/wp-login", "/"],
];

// Vecchi permalink WordPress con query (?p=123, ?page_id=, ?cat=) -> sezione piu' simile
export function resolveQueryRedirect(pathname = "/", search = "") {
  const q = new URLSearchParams(search);
  if (pathname !== "/" && pathname !== "") return null;
  if (q.has("p") || q.has("cat") || q.has("tag")) return "/news";
  if (q.has("page_id") || q.has("s")) return "/";
  return null;
}

// Ritorna la nuova URL per un vecchio path, oppure null se non c'e' redirect.
export function resolveRedirect(pathname = "/") {
  let p = decodeURIComponent(pathname).replace(/\/+$/, "") || "/";
  // Non applicare i redirect IT sugli alberi localizzati (en/de/fr).
  if (/^\/(en|de|fr)\//.test(p)) return null;
  if (exactRedirects[p]) return exactRedirects[p];
  for (const [pre, to] of prefixRedirects) if (p.startsWith(pre)) return to;
  return null;
}
